import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO,
  CLIENTE_ENCONTRADO,
  CLIENTE_FINANCIADO,
  CUIT_NOVALIDA,
  USUARIO_BLOQUEADO
} from "./step-constants";

const errores = {
  [ERROR_TECNICO]: {
    img: "error-connectiion.svg",
    title:
      "En este momento no podemos procesar la solicitud por inconvenientes técnicos",
    subtitle: "Intentá nuevamente más tarde."
  },
  [INDIVIDUO_NEGATIVO]: {
    img: "request-ok.svg",
    title: "Ya se realizó una simulación para esta empresa",
    subtitle:
      "A la brevedad, un representante de BBVA te contactará para comentarte las líneas de financiación disponibles."
  },
  [RECHAZADO_OTROS]: {
    img: "group-11.svg",
    title: "Con los datos proporcionados no pudimos hacer un cálculo online.",
    subtitle:
      "Podés acercarte a cualquiera de nuestras sucursales para recibir información detallada."
  },
  [ERROR_NOSIS]: {
    img: "authorization-error.svg",
    title: "Verificá los datos ingresados",
    subtitle:
      "Desde el botón Volver, podrás regresar a la pantalla anterior para editar los datos ingresados."
  },
  [RECHAZADO]: {
    img: "group-11.svg",
    title:
      "Según los datos que nos proporcionaste no es posible hacer un cálculo online para la Empresa.",
    subtitle: "Regresando al paso anterior podrás verificar y editar tus datos."
  },
  [CLIENTE_ENCONTRADO]: {
    img: "candado.svg",
    title: "¡Ya sos Cliente de BBVA!",
    subtitle:
      "Dirigite a una sucursal o podés encontrar los datos de contacto de tu ejecutivo ingresando a Net Cash."
  },
  [CLIENTE_FINANCIADO]: {
    img: "candado.svg",
    title: "Tu empresa ya tiene la mejor financiación",
    subtitle:
      "Si tenés que realizar una nueva financiación, podés encontrar los datos de contacto de tu ejecutivo ingresando a Net Cash."
  },
  [CUIT_NOVALIDA]: {
    img: "error.svg",
    title: "No pudimos validar tu información",
    subtitle: "Intentá de nuevo"
  },
  [USUARIO_BLOQUEADO]: {
    img: "error.svg",
    title: "Superaste la cantidad de intentos permitidos",
    subtitle: "Vas a poder reintentar la validacion en 24 horas."
  }
};

export default errores;
